import * as React from 'react';
import { ContainerElement, getMfInstanceId, PlaceholderElement, PropsData } from '../lib/mf-utils.js';
import { createReactMicrofrontend } from '../lib/react-microfrontend.js';
import { initializeHost } from '../state/index.js';
import { microfrontendContext } from './context.js';
import { setIsomorphicData } from './isomorphic-data-hook.js';
import { getPrerenderDataKey } from './MicrofrontendSSRClient.js';
export const Microfrontend = ({ children, ...props }) => {
    return React.createElement(microfrontendContext.Provider, { value: props }, children);
};
export function createReactMicrofrontendModule(component, events) {
    const mfModule = createReactMicrofrontend(component);
    async function onMount(props) {
        // initialize the Crystal host info if not already
        initializeHost({
            context: props.context,
        });
        if (typeof events?.beforeMount === 'function') {
            await events.beforeMount(props);
        }
    }
    return {
        async mount(props, element) {
            await onMount(props);
            return mfModule.mount(props, element);
        },
        async unmount(element) {
            await mfModule.unmount(element);
            if (typeof events?.afterUnmount === 'function') {
                await events.afterUnmount();
            }
        },
        update(props, element) {
            return mfModule.update(props, element);
        },
        async hydrate(mfId, instanceId) {
            const mfInstanceId = getMfInstanceId(mfId, instanceId);
            const placeholder = new PlaceholderElement(mfId, instanceId).query();
            const propsData = new PropsData(mfId, instanceId).query();
            if (!placeholder || !propsData) {
                // eslint-disable-next-line no-console
                console.warn(`Hydration error '${mfInstanceId}': prerender data is missing`);
                return;
            }
            const props = JSON.parse(propsData.text);
            await onMount(props);
            // store pre-rendered nested HTML in isomorphic data
            for (const p of placeholder.querySelectorAll(PlaceholderElement.selector)) {
                const mfInstanceId = p.getAttribute(PlaceholderElement.id);
                setPrerenderData(mfInstanceId, props.context);
            }
            // hydrate the microfrontend
            await mfModule.hydrate(mfId, instanceId);
        },
    };
}
function setPrerenderData(mfInstanceId, context) {
    const key = getPrerenderDataKey(mfInstanceId, context);
    const mfContainer = new ContainerElement(mfInstanceId).query();
    if (mfContainer) {
        setIsomorphicData(key, {
            data: mfContainer.innerHTML,
        });
    }
}
//# sourceMappingURL=Microfrontend.js.map